import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineCheckCircle } from 'react-icons/ai'; // Success 아이콘

interface AlertProps {
  message: string;
  onClose: () => void;
}

export default function Alert({ message, onClose }: AlertProps) {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0); // 진행 바 상태

  useEffect(() => {
    // 로딩 바 애니메이션
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) return prev + 1; // 진행 상태 업데이트
        clearInterval(timer);
        onClose(); // 100%가 되면 알림을 닫음
        return 100;
      });
    }, 50); // 진행 속도 조절 (3000ms = 3초)

    return () => clearInterval(timer);
  }, [onClose]);

  const handleClick = () => {
    // 알림을 클릭하면 장바구니 페이지로 이동
    navigate('/my/cart');
    onClose(); // 알림 닫기
  };

  return (
    <div className="fixed top-12 left-1/2 transform -translate-x-1/2 !z-[9999999] w-[400px] bg-white rounded-lg shadow-lg overflow-hidden">
      {/* 상단 로딩 바 */}
      <div className="h-2 bg-[#04e1cf]" style={{ width: `${progress}%` }}></div>
      
      {/* 알림 내용 */}
      <div className="p-4 flex items-start">
        <AiOutlineCheckCircle className="text-[#04e1cf] text-3xl mr-3" />
        <div>
          <h2 className="text-[#04e1cf] font-semibold text-lg">Success!</h2>
          <p className="text-sm text-gray-600 mt-1">{message}</p>
          <p className="text-sm text-gray-600 mt-1 cursor-pointer font-semibold hover:underline" onClick={handleClick}>페이지로 이동하시겠습니까?</p>
        </div>
        <button className="ml-auto text-gray-500 hover:text-gray-700" onClick={onClose}>X</button>
      </div>
    </div>
  );
}
